import { App } from 'desktop/containers';
import Home from './../desktop/containers/Home/Loadable';
import RedisMapping from '../RedisMappingLoadable';
import Catalog from 'Catalog';
import CompareLooks from './../desktop/containers/CompareLooks/Loadable';
import Checkout from '../desktop/components/Checkout/Loadable';
import Success from './../desktop/containers/Success/Loadable';
import Summary from './../desktop/containers/Summary/Loadable';
import RetryPayment from '../desktop/containers/RetryPayment/Loadable';
import MyAccount from './../desktop/containers/MyAccount/Loadable';
import Reviews from './../CommonComponents/ReviewsLoadable';
import TrackOrderStatus from './../desktop/containers/MyAccount/TrackOrderStatus/Loadable';
import InstaGallery from './../desktop/components/YotpoWidgets/InstaGalleryLoadable';
import ResetPassword from './../desktop/containers/ResetPassword/Loadable';
import ForgotPassword from './../desktop/containers/ForgotPassword/Loadable';
import EditPowerContainer from '../desktop/containers/EditPower/EditPowerContainer';
// setTimeout(() => {
//   Home.preload();
// }, 4000);
// setTimeout(() => {
//   RedisMapping.preload();
//   CompareLooks.preload();
//   MyAccount.preload();
//   Checkout.preload();
//   TrackOrderStatus.preload();
//   ResetPassword.preload();
//   ForgotPassword.preload();
// }, 8000);
// setTimeout(() => {
//   Success.preload();
//   Summary.preload();
//   RetryPayment.preload();
//   Reviews.preload();
//   InstaGallery.preload();
// }, 12000);

const routes = [
  {
    component: App,
    routes: [
      { path: '/(/*)?', exact: true, component: Home },
      { path: '/promo/:pagename(/*)?', component: Home },
      { path: '/(eyeglasses.html|sunglasses.html|premium-eyeglasses|premium-sunglasses)(/*)?', exact: true, component: Home },
      { path: '/catalog/:id(/*)?', component: Catalog },
      { path: '/category/:id(/*)?', component: Catalog },
      { path: '/catalog/category/view/:id?/:id?/:page?/:page?(/*)?', component: Catalog },
      { path: '/product/:id(/*)?', component: Catalog },
      { path: '/customer-feedback', component: Catalog },
      { path: '/catalog/product/view/:id?/:id?/:page?/:page?/:page?(/*)?', component: Catalog },
      { path: '/compare-looks(/*)?', component: CompareLooks },
      { path: '/customer/account/resetpassword', exact: true, component: ResetPassword },
      { path: '/customer/account/forgotpassword', exact: true, component: ForgotPassword },
      { path: '/customer/*', component: MyAccount },
      { path: '/checkout/onepage/success/order-summary', component: Summary },
      { path: '/checkout/onepage/success', component: Success },
      { path: '/checkout/onepage/uploadprescsms', component: Success }, // checkout/((onepage/)uploadprescsms)(?:id)(onepage/success(/))
      { path: '/checkout/onepage/retrypayment', component: RetryPayment },
      { path: '/checkout/onepage', component: Checkout },
      { path: '/reviews', component: Reviews },
      { path: '/shop-instagram', component: InstaGallery },
      { path: '/track-order(/*)?', component: TrackOrderStatus },
      { path: '/editpower/options/view', component: EditPowerContainer },
      { component: RedisMapping }
    ]
  }
];

export { routes };
